import {IStore} from "modules/types/store";

export const getEntryPointState = (store: IStore) => store.platform.entryDataState;
export const getIsNative = (store: IStore) => store.platform.isNative;
